export default "__VITE_ASSET__CMnN9GbA__"